import {
    call,
    put,
    select,
    take,
    takeEvery,
    takeLatest,
} from "redux-saga/effects";
import {
    QUERY_EXECUTE_FAILURE,
    QUERY_EXECUTE_SAGA,
    QUERY_EXECUTE_SUCCESS,
    QUERY_RESET_RESULTS_SAGA,
    QUERY_RESET_RESULTS_SAGA_FINISHED,
    QUERY_RESET_SAGA,
} from "@/Redux/Query/QueryConstants";
import { fetchQuery } from "relay-runtime";
import {
    relayAuthEnvironment,
    relayGuestEnvironment,
} from "@/RelayEnvironment";
import { graphql } from "relay-runtime";
import { QuerySagasResultQueryResponse } from "@/Redux/Query/__generated__/QuerySagasResultQuery.graphql";

function* execQuerySaga(action: any) {
    const { callback } = action.payload;
    const parameters = action.payload.parameters.map((param: any) => {
        if (param.type == "currency" && param.value != "") {
            return {
                name: param.name,
                value: Number(
                    String(param.value)
                        ?.split(".")
                        .join("")
                        .replace(",", ".")
                        .replace(/[^0-9.-]+/g, ""),
                ),
                type: param.type,
            };
        }
        return param;
    });

    try {
        const res: QuerySagasResultQueryResponse = yield fetchQuery(
            // @ts-ignore
            relayGuestEnvironment(),
            graphql`
                query QuerySagasResultQuery(
                    $queryId: Int
                    $parameters: [DBQueryParameterInput]
                ) {
                    queryResult(queryId: $queryId, parameters: $parameters) {
                        queryId
                        columns
                        rows {
                            rowId
                            values
                        }
                        aggregationRow
                    }
                }
            `,
            {
                queryId: action.payload.queryId,
                parameters: parameters,
            },
        )
            .toPromise()
            .then((data) => {
                return data;
            })
            .catch((error) => {
                throw error;
            });

        yield put({
            type: QUERY_EXECUTE_SUCCESS,
            data: {
                queryResult: res,
                params: action.payload.parameters,
            },
        });
    } catch (e: any) {
        yield call(callback, e);
        yield put({
            type: QUERY_EXECUTE_FAILURE,
            data: {
                queryResult: [],
            },
        });
    }
}

function* resetQuerySaga(action: any) {
    yield put({
        type: QUERY_EXECUTE_SUCCESS,
        data: {
            queryResult: [],
        },
    });
}

function* resetQueryResultsSaga(action: any) {
    yield put({
        type: QUERY_RESET_RESULTS_SAGA_FINISHED,
    });
}

function* querySagas() {
    yield takeLatest(QUERY_EXECUTE_SAGA, execQuerySaga);
    yield takeLatest(QUERY_RESET_SAGA, resetQuerySaga);
    yield takeLatest(QUERY_RESET_RESULTS_SAGA, resetQueryResultsSaga);
}

export default querySagas;
